module.exports = __webpack_public_path__ + "static/img/compressed.4a047e3e.gif";